import React from "react";
import { withTranslation } from "react-i18next";
import { withStyles, Slide } from "@material-ui/core";
import { images } from "../../utils/images";

function CorporateRejected(props) {
  const { t, classes } = props;

  const goToDocs = () => {
    props.router.push("/id/settings");
  };

  return (
    <Slide in direction="left">
      <div className={classes.notification}>
        <div className="contentDoc">
          <h2>{t("_corporateRejectedT")}</h2>
          <p
            dangerouslySetInnerHTML={{
              __html: t("_corporateRejectedP"),
            }}
          />
          <button onClick={() => goToDocs()} className="goToBtn">
            {t("goToSettingsDash")}
          </button>
        </div>
        <img src={images.illustrations.rejectedSolo} />
      </div>
    </Slide>
  );
}

const styles = (theme) => ({
  notification: {
    width: "95%",
    maxWidth: 900,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "10%",
    color: theme.colors.text.primary,
    background: theme.colors.background.fore,
    borderRadius: 4,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    padding: 40,
    [theme.breakpoints.down(600)]: {
      padding: 24,
    },
    "& contentDoc": {
      width: "60%",
    },
    "& img": {
      // position: "absolute",
      // right: 0,
      // top: 0,
      width: "30%",
      height: "auto",
      objectFit: "contain",
      // transform: "translate(35%, -12%)",
    },

    "& h2": {
      fontSize: 28,
      fontWeight: 600,
      zIndex: 2,
    },
    "& p": {
      fontSize: 14,
      color: theme.colors.text.secondary,
      // fontFamily: "Titillium Web",
      marginTop: 32,
      marginBottom: 64,
      lineHeight: "21px",
      width: "85%",
      zIndex: 2,

      "& a": {
        color: theme.colors.text.primary,
      },
    },
    "& button": {
      ...theme.defaults.roundBtn,
      maxWidth: 250,
      background: theme.colors.background.active,
      padding: "0 24px",
      // background: theme.colors.background.active,
      // borderRadius: 20,
      // color: theme.colors.text.primary,
      // textDecoration: "none",
      // transition: ".3s",
      // width: 220,
      // fontSize: 18,
      // height: 45,
      // display: "flex",
      // alignItems: "center",
      // justifyContent: "center",
      // fontWeight: 600,
      // fontFamily: "Titillium Web",
      // zIndex: 2,
      // "&:hover": {
      //   opacity: 0.5,
      // },
    },
  },
});

export default withStyles(styles)(withTranslation()(CorporateRejected));
